import { citiesSlice } from "./citiesSlice";
import * as defaultActions from "../../../../../redux/_common";
import { get } from "../../../../../api/requester";
import { Dispatch } from "redux";
import { getErrorMessage } from "../../../../../redux/_helpers";

const { actions } = citiesSlice;

export const setValidationErrors = actions.setValidationErrors;
const moduleUrl = '/api/masterdata/cities'

export const getItems = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getItemForEdit = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);

export const deleteItem = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const saveItem = (item: {}, id: string | null) =>
  defaultActions.saveItem(
      moduleUrl,
      actions,
      item,
      id,
  );


export const fetchCitiesFromRegion = (regionId:string) => async (dispatch:Dispatch) => {
  try {
    dispatch(actions.setItemsSelectLoading(true));
    const result = await get(`/api/masterdata/regions/${regionId}/cities`);
    dispatch(actions.setDropDownItems(result));

  } catch (errors) {
      const error = getErrorMessage(errors, "Error occured during fetching cities for region!");
      dispatch(actions.catchError({ errors: error, callType: "actionsLoading", errorProp: "errorAction" }));
  } finally {
    dispatch(actions.setItemsSelectLoading(false));
  }
}

export const fetchCitiesFromRegionBilling = (regionId:string) => async (dispatch:Dispatch) => {
  try {
    dispatch(actions.setItemsSelectLoading(true));
    const result = await get(`/api/masterdata/regions/${regionId}/cities`);
    dispatch(actions.setCitiesForBilling(result));

  } catch (errors) {
      const error = getErrorMessage(errors, "Error occured during fetching cities for region!");
      dispatch(actions.catchError({ errors: error, callType: "actionsLoading", errorProp: "errorAction" }));
  } finally {
    dispatch(actions.setItemsSelectLoading(false));
  }
}


export const getCountryFromRegion = (regionId:string) => async (dispatch:Dispatch) => {
  try {
    const result = await get(`/api/masterdata/regions/${regionId}/country`);
    dispatch(actions.countryFromRegionsFetched(result.id));
  } catch (errors) {
    const error = getErrorMessage(errors, "Error occured during fetching country for region!");
    dispatch(actions.catchError({ errors: error, callType: "actionsLoading", errorProp: "errorAction" }));
  }
};



export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);
export const clearError = () => defaultActions.clearErrors(actions);